<template>
    <div class="main">
        <c-panel title="ACEITE DE EVENTOS SUGERIDOS" titleIcon="fas fa-check-circle">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Enquanto a decisão não é tomada, o evento não altera os dias letivos da sua escola. Aceitar aplica o evento; recusar exige justificativa."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarCalendario">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <div class="u-text-center u-mt-25" v-if="calendario">
                            <h3 class="u-mb-0">{{ calendario.qtd_dias_letivos }}</h3>
                            <small>dias letivos efetivos</small>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table" v-if="instituicaoId">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Evento sugerido</th>
                            <th>Período</th>
                            <th class="u-text-center">Letivo</th>
                            <th class="hidden-mobile">Público-alvo</th>
                            <th style="width: 190px;" class="u-text-center">Decisão</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                {{ item.evento ? item.evento.nome : '—' }}
                                <span class="detalhe" v-if="item.evento && item.evento.descricao">{{ item.evento.descricao }}</span>
                            </td>
                            <td>{{ item.evento | intervalo }}</td>
                            <td class="u-text-center">{{ item.evento && item.evento.dia_letivo ? 'Sim' : 'Não' }}</td>
                            <td class="hidden-mobile">{{ item.evento ? (item.evento.publico_alvo || []).join(', ') : '' }}</td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" @click="decidir(item, 'aceito')" type="success" size="mini" plain>ACEITAR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" @click="abrirRecusa(item)" type="danger" size="mini" plain>RECUSAR</el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0">
                            <td colspan="5" class="u-text-center">Nenhum evento pendente de aceite para esta escola.</td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <el-dialog title="Recusar evento" :visible.sync="dialogo" width="520px">
                <el-form label-position="top">
                    <el-alert type="warning" :closable="false" class="u-mb-15"
                        title="A recusa exige justificativa. Ela fica registrada junto da decisão."></el-alert>
                    <el-form-item label="Justificativa">
                        <el-input v-model="justificativa" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="danger" @click="confirmarRecusa">RECUSAR EVENTO</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO C — item 42: aceite ou recusa do evento sugerido pela SMED. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    filters: {
        intervalo (e) {
            if (!e) return '—'
            const f = d => String(d || '').substring(0, 10).split('-').reverse().join('/')
            return e.data_inicio === e.data_fim ? f(e.data_inicio) : f(e.data_inicio) + ' a ' + f(e.data_fim)
        }
    },
    data: () => ({
        statusList: false,
        instituicaoId: null, periodoId: null,
        instituicoes: [], items: [],
        calendario: null,
        dialogo: false, justificativa: '', itemAtual: null
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) {
            this.instituicoes = [inst]
            this.instituicaoId = inst.id
            this.carregar()
        } else {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }
    },
    methods: {
        carregar () {
            if (!this.instituicaoId) return
            this.statusList = false
            this.items = []
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/getPendentesAceite/${this.instituicaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                } else {
                    this.items = (r.data && r.data.itens) ? r.data.itens : []
                }
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))

            this.carregarCalendario()
        },
        carregarCalendario () {
            if (!this.instituicaoId || !this.periodoId) return
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/getCalendario/${this.periodoId}/${this.instituicaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.calendario = (r.data && !r.data.erro) ? r.data : null }).catch(() => {})
        },
        abrirRecusa (item) { this.itemAtual = item; this.justificativa = ''; this.dialogo = true },
        confirmarRecusa () { this.decidir(this.itemAtual, 'recusado', this.justificativa) },
        decidir (item, situacao, justificativa) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-calendario/decidirAceite/${item.id}`,
                { situacao: situacao, justificativa: justificativa },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Decisão registrada.', type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.detalhe { display: block; font-size: 11px; color: #666; }
</style>
